import { ChangeLogItemStatus, TrialImplementationStatus } from '@shared/services/gql.service';

export class ChangeLogItemStatusConstants {
  static readonly config = [
    {
      circleClass: 'bg-aux-gray-darkest',
      text: 'Pending Review',
      textClass: 'text-aux-gray-darkest',
      value: ChangeLogItemStatus.STATUS_PENDING_REVIEW,
    },
    {
      circleClass: 'bg-aux-blue-light-200',
      text: 'Pending Approval',
      textClass: 'text-aux-blue-light-200',
      value: ChangeLogItemStatus.STATUS_PENDING_APPROVAL,
    },
    {
      circleClass: 'bg-aux-green-dark',
      text: 'Approved',
      textClass: 'text-aux-green-dark',
      value: ChangeLogItemStatus.STATUS_APPROVED,
    },
    {
      circleClass: 'bg-aux-red-dark',
      text: 'Declined',
      textClass: 'text-aux-red-dark',
      value: ChangeLogItemStatus.STATUS_DECLINED,
    },
    {
      circleClass: 'bg-aux-warn',
      text: 'On Hold',
      textClass: 'text-aux-warn',
      value: ChangeLogItemStatus.STATUS_ON_HOLD,
    },
  ];
}

export const TrialStatusMap: Record<
  TrialImplementationStatus,
  { color: string; text: string; textColor: string; tooltipValue: string }
> = {
  [TrialImplementationStatus.IMPLEMENTATION_STATUS_ARCHIVED]: {
    color: '#6E0005',
    text: 'Archived',
    textColor: '#FFFFFF',
    tooltipValue: 'Auxilius Status: Archived',
  },
  [TrialImplementationStatus.IMPLEMENTATION_STATUS_BLANK]: {
    color: '#BACAD0',
    text: 'N/A',
    textColor: '#212332',
    tooltipValue: 'Auxilius Status: N/A',
  },
  [TrialImplementationStatus.IMPLEMENTATION_STATUS_IMPLEMENTATION]: {
    color: '#5259FF',
    text: 'Implementation',
    textColor: '#FFFFFF',
    tooltipValue: 'Auxilius Status: Implementation',
  },
  [TrialImplementationStatus.IMPLEMENTATION_STATUS_LIVE]: {
    color: '#24A148',
    text: 'Live',
    textColor: '#FFFFFF',
    tooltipValue: 'Auxilius Status: Live',
  },
  [TrialImplementationStatus.IMPLEMENTATION_STATUS_PARALLEL_CLOSE]: {
    color: '#094673',
    text: 'Parallel Close',
    textColor: '#FFFFFF',
    tooltipValue: 'Auxilius Status: Parallel Close',
  },
  [TrialImplementationStatus.IMPLEMENTATION_STATUS_PENDING]: {
    color: '#F38A13',
    text: 'Pending',
    textColor: '#212332',
    tooltipValue: 'Auxilius Status: Pending',
  },
  [TrialImplementationStatus.IMPLEMENTATION_STATUS_TRAINING]: {
    color: '#F1BE01',
    text: 'Training',
    textColor: '#212332',
    tooltipValue: 'Auxilius Status: Training',
  },
  [TrialImplementationStatus.IMPLEMENTATION_STATUS_USER_ACCEPTANCE_TESTING]: {
    color: '#095B95',
    text: 'UAT',
    textColor: '#FFFFFF',
    tooltipValue: 'Auxilius Status: Testing',
  },
};
